import { useCallback, useRef } from 'react';
/**
 * Builds a function that determines if a click event represents a single or double click
 * and results in the appropriate functionality being executed.
 * @param doubleClick The function to invoke when the click event represents a double click.
 * @param click The function to invoke when the click event represents a single click.
 * @param timeout The time in milliseconds used to distinguish between single and double clicks.
 */
const useDoubleClick = (doubleClick, click, 
/** Default time out for registering double click */
timeout) => {
    // we're using useRef here for the useCallback to remember the timeout
    const clickTimeout = useRef();
    const clearClickTimeout = () => {
        if (clickTimeout) {
            clearTimeout(clickTimeout.current);
            clickTimeout.current = undefined;
        }
    };
    if (!timeout)
        timeout = 0;
    // return a memoized version of the callback that only changes if one of the dependencies has changed
    return useCallback((event) => {
        clearClickTimeout();
        if (click && event.detail === 1) {
            clickTimeout.current = window.setTimeout(() => {
                click(event);
            }, timeout);
        }
        if (event.detail % 2 === 0) {
            doubleClick(event);
        }
    }, [click, doubleClick, timeout]);
};
export { useDoubleClick };
//# sourceMappingURL=useDoubleClick.js.map